import { FC, useEffect, useMemo } from 'react';
import { SubmitButton } from '@/components/form/submit-button';
import { Button } from '@/components/ui/button';
import { useForm } from '@/forms/hooks/use-form';
import { GroupFieldValues } from '@/forms/schemas/group/field-values';
import { buildGroupFormSchema } from '@/forms/schemas/group/schema';
import { DrawerContentFormLayout } from '@/layouts/drawer-content-form-layout';
import { Group } from '@/types/group';

export type EditGroupFormProps = {
  group: Group;
  onCancel: () => void;
  onSubmit: (values: GroupFieldValues) => void;
  onDelete: () => void;
};

export const EditGroupForm: FC<EditGroupFormProps> = ({
  group,
  onCancel,
  onSubmit,
  onDelete,
}) => {
  const formSchema = useMemo(
    () =>
      buildGroupFormSchema(
        {
          canAssignAnyOrganisation: false,
          organisationName: group.organisation.name,
          organisationOptions: [],
        },
        { groupName: group.groupName },
      ),
    [group.groupName, group.organisation.name],
  );

  const { fieldItems, formState, handleSubmit, trigger } = useForm({
    schema: formSchema,
    onSubmit,
  });

  useEffect(() => {
    if (formState.submitCount > 0) {
      void trigger();
    }
  }, [formSchema, formState.submitCount, trigger]);

  return (
    <DrawerContentFormLayout
      buttonItems={[
        <Button key="delete" onClick={onDelete} variant="primary-warning">
          Delete Group
        </Button>,
        <div className="grow" key="flex"></div>,
        <Button key="cancel" onClick={onCancel} variant="secondary">
          Cancel
        </Button>,
        <SubmitButton key="submit" text="Update Group" />,
      ]}
      fieldItems={fieldItems}
      onSubmit={handleSubmit}
    />
  );
};
